import React, { useEffect, useState } from 'react'
import Header from '../Pages/Header'
import Sidebar from '../Pages/Sidebar'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { PAY_URL, formatDate } from '../../../BaseURL';
import toast from 'react-hot-toast';
import axios from 'axios';

const ManageProject = () => {

    const [project, setProject] = useState({
        name: "",
        work_order_no: "",
        details: "",
        po_date: "",
        startDate: "",
        endDate: "",
        firm_id: "",
        year_id: "",
    });

    const [firms, setFirms] = useState([]);
    const [years, setYears] = useState([]);
    const [disable, setDisable] = useState(false);
    const [selectValue, setSelectValue] = useState(true);
    const [error, setError] = useState({});

    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state;

    useEffect(() => {
        if (localStorage.getItem('PAY_USER_TOKEN') === null) {
            navigate("/user/login");
        }
        
        getFirms();
        getYears();
    }, []);

    useEffect(() => {
        if (data) {
            setProject({
                name: data?.name || "",
                work_order_no: data?.work_order_no || "",
                details: data?.details || "",
                po_date: data?.po_date ? new Date(data.po_date).toISOString().split('T')[0] : "",
                startDate: data?.startDate ? new Date(data.startDate).toISOString().split('T')[0] : "",
                endDate: data?.endDate ? new Date(data.endDate).toISOString().split('T')[0] : "",
                firm_id: data?.firm_id?._id || "",
                year_id: data?.year_id?._id || "",
            });
            setSelectValue(data?.status);
        }
    }, [data])

    const getFirms = () => {
        axios.get(`${PAY_URL}/user/get-firm`, {
            headers: { Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN') }
        }).then((response) => {
            if (response.data.success) {
                setFirms(response.data.data);
            }
        }).catch((err) => console.log(err));
    };

    const getYears = () => {
        axios.get(`${PAY_URL}/user/get-year`, {
            headers: { Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN') }
        }).then((response) => {
            if (response.data.success) {
                setYears(response.data.data);
            }
        }).catch((err) => console.log(err));
    };

    const handleChange = (e) => {
        setProject({ ...project, [e.target.name]: e.target.value });
    }

    const handleRadioChange = (event) => {
        setSelectValue(event.target.checked);
    };

    const validation = () => {
        let isValid = true;
        let err = {};

        if (!project.name || !project.name.trim()) {
            isValid = false;
            err['name_err'] = "Please enter project name"
        }
        if (!project.work_order_no || !project.work_order_no.trim()) {
            isValid = false;
            err['work_order_no_err'] = "Please enter work order"
        }
        if (!project.firm_id) {
            isValid = false;
            err['firm_id_err'] = "Please select firm"
        }
        if (!project.year_id) {
            isValid = false;
            err['year_id_err'] = "Please select year"
        }
        if (!project.po_date) {
            isValid = false;
            err['po_date_err'] = "Please select PO date"
        }

        setError(err);
        return isValid;
    }

    const handleSubmit = () => {
        if (validation()) {
            setDisable(true);

            const bodyFormData = new URLSearchParams();
            bodyFormData.append('name', project.name);
            bodyFormData.append('work_order_no', project.work_order_no);
            bodyFormData.append('details', project.details);
            bodyFormData.append('po_date', project.po_date);
            bodyFormData.append('startDate', project.startDate);
            bodyFormData.append('endDate', project.endDate);
            bodyFormData.append('firm_id', project.firm_id);
            bodyFormData.append('year_id', project.year_id);
            bodyFormData.append('status', selectValue);

            if (data?._id) {
                bodyFormData.append('id', data._id)
            }

            axios({
                method: 'post',
                url: `${PAY_URL}/user/manage-project`,
                data: bodyFormData,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN') }
            }).then((response) => {
                if (response.data.success === true) {
                    toast.success(response.data.message)
                    navigate('/user/project-management');
                    setDisable(false);
                } else {
                    toast.error(response.data.message);
                    setDisable(false);
                }
            }).catch((error) => {
                console.log(error);
                toast.error(error?.response?.data?.message || "Something went wrong");
                setDisable(false);
            })
        }
    }

    const handleReset = () => {
        setProject({
            name: "",
            work_order_no: "",
            details: "",
            po_date: "",
            startDate: "",
            endDate: "",
            firm_id: "",
            year_id: "",
        });
        setError({});
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <>
            <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
                <Header handleOpen={handleOpen} />
                <Sidebar />
                <div className="page-wrapper">
                    <div className="content container-fluid">
                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title">{data?._id ? 'Edit' : 'Add'} Project</h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/user/dashboard">Dashboard</Link></li>
                                        <li className="breadcrumb-item"><Link to='/user/project-management'>Project Management</Link></li>
                                        <li className="breadcrumb-item active">{data?._id ? 'Edit' : 'Add'} Project</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="card p-3 basicform">
                            <div className="row card_id">
                                <div className="col-md-6 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label className="form-label">Project Name <span className='text-danger'>*</span></label>
                                            <input type="text" className="form-control"
                                                value={project.name}
                                                name='name' onChange={handleChange} />
                                            <div className='error'>{error.name_err}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label className="form-label">Firm <span className='text-danger'>*</span></label>
                                            <select className="form-select form-control"
                                                value={project.firm_id}
                                                onChange={handleChange} name='firm_id'>
                                                <option value="">Select Firm</option>
                                                {firms.map((f) => (
                                                    <option key={f._id} value={f._id}>
                                                        {f.name}
                                                    </option>
                                                ))}
                                            </select>
                                            <div className='error'>{error.firm_id_err}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label className="form-label">Year <span className='text-danger'>*</span></label>
                                            <select className="form-select form-control"
                                                value={project.year_id}
                                                onChange={handleChange} name='year_id'>
                                                <option value="">Select Year</option>
                                                {years.map((y) => (
                                                    <option key={y._id} value={y._id}>
        {new Date(y.start_year).getFullYear()} - {new Date(y.end_year).getFullYear()}
                                                    </option>
                                                ))}
                                            </select>
                                            <div className='error'>{error.year_id_err}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row card_id">
                                <div className="col-md-6 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label className="form-label">Work Order No <span className='text-danger'>*</span></label>
                                            <input type="text" className="form-control"
                                                value={project.work_order_no}
                                                name='work_order_no' onChange={handleChange} />
                                            <div className='error'>{error.work_order_no_err}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label className="form-label">PO Date <span className='text-danger'>*</span></label>
                                            <input type="date" className="form-control"
                                                value={project.po_date}
                                                name='po_date' onChange={handleChange} />
                                            <div className='error'>{error.po_date_err}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label className="form-label">Start Date</label>
                                            <input type="date" className="form-control"
                                                value={project.startDate}
                                                name='startDate' onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row card_id">
                                <div className="col-md-6 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label className="form-label">End Date</label>
                                            <input type="date" className="form-control"
                                                value={project.endDate}
                                                name='endDate' onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3">
                                            <label className="form-label">Details</label>
                                            <textarea className="form-control"
                                                value={project.details}
                                                name='details' onChange={handleChange}></textarea>
                                        </div>
                                    </div>
                                </div>

                                {data?._id && (
                                    <div className='col-md-6 col-lg-4 col-xxl-4 col-sm-12'>
                                        <div className="cardNum">
                                            <div className="mb-3">
                                                <label className="form-label">Status</label>
                                                <div className="form-check form-switch mt-2">
                                                    <input className="form-check-input" type="checkbox" role="switch" onChange={handleRadioChange} checked={selectValue} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="row card_id mt-4 sm-mt-3">
                                <div className=" col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                    <div className="cardNum">
                                        <div className="mb-3 d-flex gap-2">
                                            <button className="btn btn-primary w-50" type='button' onClick={handleSubmit} disabled={disable}>{disable ? "Processing..." : (data?._id ? 'Update' : 'Submit')}</button>
                                            <button className="btn btn-outline-secondary w-50" onClick={handleReset}>Reset</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ManageProject;
